import React, { type ReactNode } from 'react';
import { xcss, Flex, Box } from '@atlaskit/primitives';

type Props = {
	symbol: ReactNode;
	label: string;
};

const LegendItem = ({ symbol, label }: Props) => (
	<Flex direction="row" gap="space.100" alignItems="center" xcss={containerStyles} as="li">
		<Box xcss={symbolStyles}>{symbol}</Box>
		{label}
	</Flex>
);

export default LegendItem;

const containerStyles = xcss({
	color: 'color.text.subtle',
	margin: '0',
});

const symbolStyles = xcss({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	minWidth: '24px',
	height: '20px',
});
